import { render, staticRenderFns } from "./MarketplaceIcon.vue?vue&type=template&id=5cacd648"
import script from "./MarketplaceIcon.vue?vue&type=script&lang=ts"
export * from "./MarketplaceIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports